import { mdiImageAlbum } from '@mdi/js'

export default {
  title: 'Slider Kadis',
  to: 'slider-hod-list',
  icon: mdiImageAlbum,
  resource: 'SliderHeadDepartment',
  action: 'read',
}
